<template>
  <div id="user-layout">
    <div class="header-area">
      <HeaderComponentVue />
    </div>
    <div class="contents-area">
      <router-view />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import HeaderComponentVue from "@/common/components/HeaderComponent.vue";

export default defineComponent({
  setup() {
    return {};
  },
  data() {
    return {
      title: "",
    };
  },
  components: { HeaderComponentVue },
  methods: {
    helloWorld() {
      console.log("helloWorld!");
    },
  },
  created() {
    console.log("[LottoHome] created");
    window.scrollTo(0, 0);
  },
});
</script>

<style lang="scss" scoped></style>
